<template>
  <div
    class="settings"
    :class="{ active: menu }">

    <div
      v-for="menu_item in menus"
      v-show="!loading"
      :key="menu_item.id">

      <label>
        <input
          type="checkbox"
          :checked="menu_item.checked"
          @click="toggleChecked(menu_item.id)">

        {{ menu_item.name }}
      </label>
    </div>
  </div>
</template>

<script>
  import { DateTime } from "luxon";
  import mixins from "../mixins.js";

  export default {
    props: ["menu", "menus", "loading"],

    mixins: [mixins],

    methods: {
      toggleChecked(menuItem) {
        Object.keys(this.menus).forEach(key => {
          if (this.menus[key].id == menuItem) {
            const menuItem = this.menus[key];
            const newStatus = !menuItem.checked;

            // Set new status.
            this.menus[key].checked = newStatus;
          }
        });

        // Add menus to localStorage as calendars.
        localStorage.setItem("umcancer-event-app-calendars", JSON.stringify(this.menus));

        // Notify parent component of a click.
        this.$emit("toggle-item");
      }
    }
  }

</script>

<style scoped>

  label {
    border-bottom: 1px solid #b6b6b6;
    display: block;
    font-size: 2rem;
    padding: 1rem;
  }

  .settings {
    background-color: #F0F5FF;
    display: none;
  }

  .settings.active {
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue